__turbopack_context__.v({
  "container": "styles-module-scss-module__BATO0G__container",
});
